import { DeleteOutlined } from '@ant-design/icons/lib'
import { Row } from 'antd'
import { useSubItemDelete } from 'app/components/Core/Checkout/hooks/useProduct'
import SubItemDetail from 'app/components/Core/SubItem/Detail'
import Form from 'app/components/Core/SubItem/Form'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { BaseDateNormalizer } from 'app/lib/apollo/normalizers/LineItem'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useLazyQuery } from 'app/lib/hooks/useQuery'
import { queries, RecordTypeEnum } from 'app/queries'
import { useEffect } from 'react'
import testIds from 'test_ids.json'

interface Props {
  subItemId: number
  onClose: () => void
  portalId: string
  onSuccess?: () => void
  showDelete?: boolean
}

const SubItemUpdate: React.FC<Props> = ({
  subItemId,
  onClose,
  portalId,
  onSuccess: onUpdateSuccess,
  showDelete
}) => {
  const { loading: dLoading, execute: destroy } = useSubItemDelete()

  const {
    execute: show,
    data: { subItem },
    loading: sLoading
  } = useLazyQuery<{ subItem: ISubItem }>(queries.subItem.get, {
    normalizer: (data) => ({ subItem: BaseDateNormalizer(data.subItem) }),
    // do not refetch item on destroy
    nextFetchPolicy: 'cache-only'
  })

  const {
    confirmfy: { open }
  } = useFeedbacker()

  useEffect(() => {
    subItemId && show({ variables: { id: subItemId } })
  }, [subItemId])

  const onSuccess = () => {
    onClose()
    onUpdateSuccess?.()
  }

  const onConfirm = async () => {
    await destroy({ id: subItemId })
    onSuccess()
  }

  const onDelete = () => {
    open({
      recordType: RecordTypeEnum.subItem,
      action: 'destroy',
      onConfirm: () => onConfirm(),
      values: { name: subItem.name }
    })
  }

  return (
    <Row>
      <KCol span={24} loading={sLoading}>
        <If condition={subItem}>
          <Row gutter={[0, 24]}>
            <KCol span={24}>
              <SubItemDetail
                member={subItem}
                props={{
                  extra: showDelete && (
                    <Button
                      type="secondary"
                      onClick={onDelete}
                      loading={dLoading}
                      data-testid={testIds.checkout.machines.sub_item.delete_button}
                      icon={
                        <If condition={!subItem.freeAttachment}>
                          <DeleteOutlined />
                        </If>
                      }
                    />
                  )
                }}
              />
            </KCol>
            <KCol span={24}>
              <Form props={{ portalId, onSuccess }} member={subItem} />
            </KCol>
          </Row>
        </If>
      </KCol>
    </Row>
  )
}

export default SubItemUpdate
